module.exports = __webpack_public_path__ + "media/react/payments/assets/apple_pay_dark-581fa4d7d685595ebbdaf0da9073b668.svg";